import variant_types from "@/methods/variant_types"
import VariantListService from "@/services/VariantListService"
import VariantInterpretationService from "@/services/VariantInterpretationService"
import { store } from '@/store'

export default {

    /**
    * Activates all loading spinners, runs a biomarker search, sorts the retrieved biomarker types and stores them in the Vuex store
    *
    */
    async startRequestVariantList(query, refgen, oncokbkey = "") {
        store.dispatch('setResultsLoaded', false)
        // clear all previous request results
        //store.dispatch("setVariants", {})
        //store.dispatch('setGenomeVersion', '')

        // update all loading spinners
        store.dispatch('setProcessState', ["load-genompos", '<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>'])
        store.dispatch('setProcessState', ["load-gene-name", '<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>'])
        store.dispatch('setProcessState', ["load-variant-exchange", '<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>'])
        store.dispatch('setProcessState', ["load-dbsnp", '<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>'])
        store.dispatch('setProcessState', ["load-clinvar", '<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>'])
        store.dispatch('setProcessState', ["load-revel", '<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>'])
        store.dispatch('setProcessState', ["load-loftool", '<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>'])
        store.dispatch('setProcessState', ["load-vusp", '<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>'])
        store.dispatch('setProcessState', ["load-interpretations", '<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>'])

        //query += '&genome=' + store.getters.getGenomeVersion
        await this.getVariantSearch(query, refgen, oncokbkey)
        //alert("OK")
        //await variant_types.sortBiomarkersVariantType()
        //this.uploaddatarv += 1;

        // load drug classes
        var request_id = store.getters.requestID
        await this.analyzeVariants("drug_classification", "1", "pub", null, request_id = request_id)
        //alert("Ok")

        store.dispatch('setResultsLoaded', true)
        //store.dispatch('setProcessState',["downloadButtons", [{"CSV":"csv" },{"PDF":"pdf"}] ])
        store.dispatch('setProcessState', ["downloadButtons",
            [
                { "Download": ["patho-csv", "mdi-file-pdf-box", "Annotated variants (CSV)"] },
                { "Download": ["treatments-csv", "mdi-file-pdf-box", "Treatment results (CSV)"] }
            ]
        ])
        //alert("ok")

        store.dispatch('setProcessState', ["load-genompos", ""])
        store.dispatch('setProcessState', ["load-gene-name", ""])
        store.dispatch('setProcessState', ["load-variant-exchange", ""])
        store.dispatch('setProcessState', ["load-dbsnp", ""])
        store.dispatch('setProcessState', ["load-clinvar", ""])
        store.dispatch('setProcessState', ["load-revel", ""])
        store.dispatch('setProcessState', ["load-loftool", ""])
        store.dispatch('setProcessState', ["load-vusp", ""])
        store.dispatch('setProcessState', ["load-interpretations", ""])
    },
    async getAnnotatedModules(dataID, data_dir) {
        let url = store.getters.getPathVariable("methods_get_annotated_modules")

        await VariantInterpretationService.get_annotation_modules((event) => {
            this.progress = Math.round((100 * event.loaded) / event.total);
        }, store.getters.getIDData, url, data_dir)
            .then((response) => {
                //alert("modules: "+response.data)
                store.dispatch("setAnnotatedModules", response.data)
            })
            .catch(() => {
                console.error("Error retrieving annotated modules for " + store.getters.getIDData)
            });
    },
    /*
    * Send parallel annotation requests, while displaying the results as soon as they have been loaded
    *
    */
    async analyzeURLs(dataID, modules, mode) {

        let genome_version = store.getters.getGenomeVersion
        let dataDir = "pub" //"loc"
        let url = store.getters.getPathVariable("methods_analyze_variants")

        await this.getAnnotatedModules(dataID, dataDir)
        //alert("annotated modules: "+store.getters.annotatedModules)

        /*if (!store.getters.annotatedModules.includes("UTA_Adapter")) {
            await this.analyzeUpdate(dataID, url,dataDir, "UTA_Adapter", mode, genome_version,false)
        }

        if (!store.getters.annotatedModules.includes("UTA_Adapter_gene")) {
            await this.analyzeUpdate(dataID, url,dataDir, "UTA_Adapter_gene", mode, genome_version,false)
        }*/
        //alert(store.getters.requestID)
        await this.analyzeUpdate(dataID, url, dataDir, "all", mode, genome_version, false)
        store.dispatch('setResultsLoaded', false)
        /*await Promise.all([
            this.analyzeUpdate(dataID, url,dataDir, "Genomic_comb", mode, genome_version,false),
            this.analyzeUpdate(dataID, url,dataDir, "dbsnp", mode, genome_version,false),
            this.analyzeUpdate(dataID, url,dataDir, "clinvar", mode, genome_version),
            this.analyzeUpdate(dataID, url,dataDir, "revel", mode, genome_version),
            this.analyzeUpdate(dataID, url,dataDir, "primateai", mode, genome_version,false),
            this.analyzeUpdate(dataID, url,dataDir, "alphamissense", mode, genome_version,false),
            this.analyzeUpdate(dataID, url,dataDir, "mvp", mode, genome_version),
            this.analyzeUpdate(dataID, url,dataDir, "dbnsfp", mode, genome_version),
        ])*/

        /*await Promise.all([
            this.analyzeUpdate(dataID, url,dataDir, "biomarker_types", mode, genome_version,false),

            this.analyzeUpdate(dataID, url,dataDir, "loftool", mode, genome_version,false),
            this.analyzeUpdate(dataID, url,dataDir, "vuspredict", mode, genome_version),

            this.analyzeUpdate(dataID, url,dataDir, "gencode", mode, genome_version,false),
            this.analyzeUpdate(dataID, url,dataDir, "gencode_genomic", mode, genome_version,false),
            this.analyzeUpdate(dataID, url,dataDir, "UTA_Adapter_protein_sequence", mode, genome_version,false),
            this.analyzeUpdate(dataID, url,dataDir, "vus_predict", mode, genome_version),

            this.analyzeUpdate(dataID, url,dataDir, "metakb", mode, genome_version,false),
            this.analyzeUpdate(dataID, url,dataDir, "civic", mode, genome_version,false),
            this.analyzeUpdate(dataID, url,dataDir, "oncokb", mode, genome_version),
        ])
        */

        //await this.analyzeUpdate(dataID, url,dataDir, "onkopus_aggregator", mode, genome_version,false),
        //alert(store.getters.requestID)
        await this.analyzeUpdate(dataID, url,dataDir, "drug_classification", mode, genome_version,false, store.getters.requestID)
        //await this.analyzeUpdate(dataID, url,dataDir, "biomarker_types", mode, genome_version, false)


        let q = ''
        if (store.getters.getIDData == 'sample') {
            q = '?id=sample'
        } else if ((store.getters.getIDData === undefined) || (store.getters.getIDData.localeCompare("undefined") == 0)) {
            q = "?id=" + route.query.id + "&data_dir=" + data_dir
            store.dispatch("setIdData", route.query.id)
        } else {
            q = "?id=" + store.getters.getIDData + "&data_dir=pub"
        }
        //await this.getVariants(q, dataDir)

        store.dispatch('setProcessState', ["load-results", ''])
        //store.dispatch('setCSVDownload','<v-btn style="background-color:#d5d5d5;margin:10px;"><v-icon icon="mdi-table"></v-icon>CSV</v-btn>')
        //store.dispatch('setPDFDownload','<v-btn style="background-color:#d5d5d5;margin:10px;"><v-icon icon="mdi-table"></v-icon>PDF</v-btn>')

        store.dispatch('setProcessState', ["load-results", ''])
        store.dispatch('setResultsLoaded', true)

    },
    async analyzeUpdate(dataID, url, data_dir, module, mode, genome_version, pass_data = false, request_id = null) {

        if (!store.getters.annotatedModules.includes(module)) {
            let q = ''
            let id_data = store.getters.getIDData;
            if (id_data == 'sample') {
                q = '?id=sample'
            } else if ((id_data === undefined) || (id_data.localeCompare("undefined") == 0)) {
                q = "?id=" + route.query.id + "&data_dir=" + data_dir
                store.dispatch("setIdData", route.query.id)
            } else {
                q = "?id=" + id_data + "&data_dir=pub"
            }

            let data = null
            if (pass_data) {
                data = store.getters.variants
            } else {
                data = null
            }

            await this.analyzeVariants(module, mode, data_dir, data, request_id = request_id)
            let moduleSpinner = "load-" + module
            store.dispatch('setProcessState', [moduleSpinner, ""])
            //if (reload) {
            //    await this.getVariants(q, data_dir)
            //}
        }
    },
    decodeIfDoubleEncoded(obj) {
      try {
        // Attempt the first decode
        let decodedOnce = JSON.parse(obj);

        // Check if the result is a string
        if (typeof decodedOnce === 'string') {
          try {
            // Attempt a second decode
            return JSON.parse(decodedOnce);
          } catch (e) {
            // If the second decode fails, return the single-decoded result
            return decodedOnce;
          }
        }

        // If not a string, return the single-decoded result
        return decodedOnce;
      } catch (e) {
        // If the input is not valid JSON, return as-is
        console.warn("Invalid JSON input:", obj);
        return obj;
      }
    },
    /**
    * Run annotation for a specific module
    *
    *
    **/
    async analyzeVariants(module, mode, data_dir = "pub", data = null, request_id = null) {
        let url = store.getters.getPathVariable("methods_analyze_variants")
        let tumorType = encodeURI(store.getters.selectedTumorType)

        await VariantInterpretationService.analyze((event) => {
            this.progress = Math.round((100 * event.loaded) / event.total);
        }, store.getters.getIDData, url, data_dir, module, mode, "hg38", request_id, tumorType)
            .then((response) => {
                //let newdata = Object.assign({}, store.getters.variants, response.data);
                //store.dispatch("setVariants", response.data.snvs)
                //alert(JSON.stringify(response.data))

                var variant_data = response.data["data"]
                //alert(response.data["header"]["request_id"])

                //if (request_id == null) {
                    request_id = response.data["header"]["request_id"]
                    //alert("reqID " + request_id)
                    store.dispatch("setRequestID", request_id)
                //}

                //store.dispatch("setVariants", response.data)
                store.dispatch("setVariants", variant_data)
                variant_types.sortBiomarkersVariantTypeMainTypes(variant_data)
                this.generateColumns()
            })
            .catch((msg) => {
                console.error("error analyzing variant data " + msg)
            });
    },
    /*
    *
    *
    */
    async getVariants(q, data_dir = "pub") {

        q = q + '&data_dir=' + data_dir
        let url = store.getters.getPathVariable("methods_get_id_variant_data") + q

        await VariantListService.getVariants((event) => {
            this.progress = Math.round((100 * event.loaded) / event.total);
        }, url
        )
            .then((response) => {
                this.isLoading = false;
                if (data_dir.localeCompare("pub") == 0) {

                    /*response.data.sort(function (a, b) {
                                if (("variant_data" in a) && ("variant_data" in b)) {
                                    return a["variant_data"]["file_pos"].localeCompare(b["variant_data"]["file_pos"]);
                                } else {
                                    return 0;
                                }
                    });*/

                    //let module = "variant_data"
                    //let key = "file_pos"
                    //let key1 = "file_pos"
                    //let key1 = "file_pos"
                    //let data_new = {}
                    //let sorted_new = Object.keys(response.data).sort( (x,y) => response.data[x][module][key] > response.data[y][module][key] ? -1 : 1).map(f => response.data[f] )
                    //alert(JSON.stringify(Object.keys(response.data)))
                    //response.data = Object.keys(response.data).sort( (x,y) => response.data[x][module][key] > response.data[y][module][key] ? -1 : 1).map(f => response.data[f] )
                    //response.data = Object.keys(response.data).sort( (x,y) => response.data[x][module][key] > response.data[y][module][key] ? -1 : 1).map(f => response.data[f] )
                    //response.data = Object.keys(response.data).sort( (x,y) => response.data[x][module][key] > response.data[y][module][key] ? -1 : 1).map(f => response.data )
                    //response.data = response.data[0]
                    //alert(JSON.stringify(response.data))

                    store.dispatch("setVariants", response.data)

                    request_id = response.data["header"]["request_id"]
                    //alert("reqID " + request_id)
                    store.dispatch("setRequestID", request_id)

                    //store.dispatch("setSNVs", response.data)
                } else if (data_dir.localeCompare("loc") == 0) {
                    store.dispatch("setIdVariants", response.data)
                }
                this.generateColumns()
            })
            .catch(() => {
                console.error("error loading variant data");
            })
    },
    /**
    * Runs the full Onkopus annotation for a search term
    * @param q: Single or list of biomarkers
    * @return
    */
    async getVariantSearch(q, refgen, oncokbkey = "", reset = true) {

        let tumorType = encodeURI(store.getters.selectedTumorType)
        let url = store.getters.getPathVariable("methods_get_variant_search") + '?q=' + q + '&genome_version=' + refgen + '&tumor_type=' + tumorType

        await VariantListService.getVariants((event) => {
            this.progress = Math.round((100 * event.loaded) / event.total);
        }, url, oncokbkey
        )
            .then((response) => {
                this.isLoading = false;
                var variant_data = response.data["data"]
                var request_id = response.data["header"]["request_id"]
                store.dispatch("setRequestID", request_id)

                //store.dispatch("setVariants", response.data)
                store.dispatch("setVariants", variant_data)
                variant_types.sortBiomarkersVariantTypeMainTypes(variant_data)
                //variant_types.sortBiomarkersVariantType()
            })
            .catch(() => {
                console.error("error retrieving variant query data");
            })
    },
    async analyzeVariantsParallel(route, data_dir = "pub") {
        store.dispatch('setProcessState', ["load-genompos", '<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>'])
        store.dispatch('setProcessState', ["load-gene-name", '<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>'])
        store.dispatch('setProcessState', ["load-variant-exchange", '<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>'])
        store.dispatch('setProcessState', ["load-dbsnp", '<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>'])
        store.dispatch('setProcessState', ["load-clinvar", '<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>'])
        store.dispatch('setProcessState', ["load-revel", '<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>'])
        store.dispatch('setProcessState', ["load-loftool", '<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>'])
        store.dispatch('setProcessState', ["load-vusp", '<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>'])
        store.dispatch('setProcessState', ["load-interpretations", '<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>'])

        // Genome version
        if (route.params.genome) {
            store.dispatch('setGenomeVersion', route.params.genome)
        }

        let q = ''
        let dataID = ''
        let id_data = store.getters.getIDData;
        if (id_data == 'sample') {
            q = '?id=sample'
            dataID = "sample"
        } else if ((id_data === undefined) || (id_data.localeCompare("undefined") == 0)) {
            q = "?id=" + route.query.id + "&data_dir=" + data_dir
            store.dispatch("setIdData", route.query.id)
            dataID = route.query.id
        } else {
            q = "?id=" + id_data + "&data_dir=pub"
            dataID = id_data
        }

        console.log("analysis uploadData")
        //await variant_annotation.getVariants(q)
        store.dispatch('setProcessState', ["load-genompos", ""])

        // CCS LiftOver
        //if (store.getters.getEnvVariable("active_modules").includes("liftover")) {
        //    await this.analyzeVariants("liftover",1, data_dir=data_dir)
        //}

        let mode = 1
        await this.analyzeURLs(dataID, ["dbnsfp", "clinvar"], mode)

        //await variant_types.sortBiomarkersVariantType()

        //store.dispatch('setProcessState',["downloadButtons", [{"CSV":"csv" },{"PDF":"pdf"}] ])
        /*store.dispatch('setProcessState',["downloadButtons",
                        [
                            {"Download":["patho-csv","mdi-file-pdf-box","Annotated variants (CSV)"] },
                            {"Download":["treatments-csv","mdi-file-pdf-box","Treatment results (CSV)"] }
                        ]
                    ])*/
    },
    /**
    * Annotates an uploaded variant file
    *
    *
    */
    async analyzeVariantsSequential(route, data_dir = "pub") {
        if (!route.query.annotate) {

            // Refresh page
            store.dispatch('setProcessState', ["load-genompos", '<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>'])
            store.dispatch('setProcessState', ["load-gene-name", '<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>'])
            store.dispatch('setProcessState', ["load-variant-exchange", '<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>'])
            store.dispatch('setProcessState', ["load-dbsnp", '<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>'])
            store.dispatch('setProcessState', ["load-clinvar", '<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>'])
            store.dispatch('setProcessState', ["load-revel", '<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>'])
            store.dispatch('setProcessState', ["load-loftool", '<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>'])
            store.dispatch('setProcessState', ["load-vusp", '<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>'])
            store.dispatch('setProcessState', ["load-interpretations", '<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>'])

            // Genome version
            if (route.params.genome) {
                store.dispatch('setGenomeVersion', route.params.genome)
            }

            let q = ''
            let id_data = store.getters.getIDData;
            if (id_data == 'sample') {
                q = '?id=sample'
            } else if ((id_data === undefined) || (id_data.localeCompare("undefined") == 0)) {
                q = "?id=" + route.query.id + "&data_dir=" + data_dir
                store.dispatch("setIdData", route.query.id)
            } else {
                q = "?id=" + id_data + "&data_dir=pub"
            }

            console.log("analysis uploadData")
            //await variant_annotation.getVariants(q)
            store.dispatch('setProcessState', ["load-genompos", ""])

            // CCS LiftOver
            if (store.getters.getEnvVariable("active_modules").includes("ccs_liftover")) {
                await this.analyzeVariants("ccs_liftover", 1, data_dir = data_dir)
            }

            // dbNSFP
            if (store.getters.getEnvVariable("active_modules").includes("dbnsfp")) {
                await this.analyzeVariants("dbnsfp", 1, data_dir = data_dir)
            }

            // dbSNP
            if (store.getters.getEnvVariable("active_modules").includes("dbsnp")) {
                await this.analyzeVariants("dbsnp", 1, data_dir = data_dir)
                await this.getVariants(q, data_dir = data_dir)
                await variant_types.sortBiomarkersVariantType()
            }
            store.dispatch('setProcessState', ["load-dbsnp", ""])

            // ClinVar
            if (store.getters.getEnvVariable("active_modules").includes("clinvar")) {
                await this.analyzeVariants("clinvar", 1, data_dir = data_dir)
                await this.getVariants(q, data_dir = data_dir)
                await variant_types.sortBiomarkersVariantType()
            }
            store.dispatch('setProcessState', ["load-clinvar", ""])

            // CCS
            if (store.getters.getEnvVariable("active_modules").includes("ccs")) {
                await this.analyzeVariants("uta", 1, data_dir = data_dir)
                //await this.getVariants(q)
                //await variant_types.sortBiomarkersVariantType()
            }

            // Identify biomarker types
            if (store.getters.getEnvVariable("active_modules").includes("biomarker_types")) {
                await this.analyzeVariants("biomarker_types", 0, data_dir = data_dir)
                await this.getVariants(q, data_dir = data_dir)
                await variant_types.sortBiomarkersVariantType()
            }

            store.dispatch('setProcessState', ["load-gene-name", ""])
            store.dispatch('setProcessState', ["load-variant-exchange", ""])

            // REVEL
            if (store.getters.getEnvVariable("active_modules").includes("revel")) {
                await this.analyzeVariants("revel", 1, data_dir = data_dir)
                await this.getVariants(q, data_dir = data_dir)
                await variant_types.sortBiomarkersVariantType()
            }
            store.dispatch('setProcessState', ["load-revel", ""])

            // LoFTool
            if (store.getters.getEnvVariable("active_modules").includes("loftool")) {
                await this.analyzeVariants("loftool", 1, data_dir = data_dir)
                await this.getVariants(q, data_dir = data_dir)
                await variant_types.sortBiomarkersVariantType()
            }
            store.dispatch('setProcessState', ["load-loftool", ""])

            // VUS-Predict
            if (store.getters.getEnvVariable("active_modules").includes("vus-predict")) {
                await this.analyzeVariants("vuspredict", 1, data_dir = data_dir)
                await this.getVariants(q, data_dir = data_dir)
                await variant_types.sortBiomarkersVariantType()
            }
            store.dispatch('setProcessState', ["load-vusp", ""])

            // CIViC
            if (store.getters.getEnvVariable("active_modules").includes("civic")) {
                await this.analyzeVariants("civic", 1, data_dir = data_dir)
                //await this.getVariants(q)
            }

            // OncoKB
            if (store.getters.getEnvVariable("active_modules").includes("oncokb")) {
                await this.analyzeVariants("oncokb", 1, data_dir = data_dir)
                //await this.getVariants(q)
            }

            // metaKB
            if (store.getters.getEnvVariable("active_modules").includes("metakb")) {
                await this.analyzeVariants("metakb", 1, data_dir = data_dir)
                //await this.getVariants(q)
            }

            // Aggregator
            if (store.getters.getEnvVariable("active_modules").includes("aggregator")) {
                await this.analyzeVariants("aggregator", 1, data_dir = data_dir)
                await this.getVariants(q, data_dir = data_dir)
            }
            store.dispatch('setProcessState', ["load-interpretations", ""])

            // MVP annotation
            if (store.getters.getEnvVariable("active_modules").includes("mvp")) {
                await this.analyzeVariants("mvp", 1, data_dir = data_dir)
                await this.getVariants(q, data_dir = data_dir)
            }

            await variant_types.sortBiomarkersVariantType()

        } else {
            // Genome version
            if (route.params.genome) {
                store.dispatch('setGenomeVersion', route.params.genome)
            }

            let q = ''
            if (store.getters.getIDData == 'sample') {
                q = '?id=sample'
            } else {
                q = "?id=" + store.getters.getIDData + "&data_dir=pub"
            }

            // no automated annotation
            await this.getVariants(q, data_dir = data_dir)
            await variant_types.sortBiomarkersVariantType()

            store.dispatch('setProcessState', ["load-genompos", ""])
            store.dispatch('setProcessState', ["load-gene-name", ""])
            store.dispatch('setProcessState', ["load-variant-exchange", ""])
            store.dispatch('setProcessState', ["load-dbsnp", ""])
            store.dispatch('setProcessState', ["load-clinvar", ""])
            store.dispatch('setProcessState', ["load-revel", ""])
            store.dispatch('setProcessState', ["load-loftool", ""])
            store.dispatch('setProcessState', ["load-vusp", ""])
            store.dispatch('setProcessState', ["load-interpretations", ""])
        }

    },
    async loadVariantTypes(q, data_dir) {
        await this.getVariants(q, data_dir = data_dir)
        await variant_types.sortBiomarkersVariantType(data_dir = data_dir)
    },
    async generateColumns() {
        let columns = []

        //if (route.query.columns) {
        //} else {
        for (let key in store.getters.snvs) {
            if ("variant_data" in store.getters.snvs[key]) {
                if ("info_features" in store.getters.snvs[key]["variant_data"]) {
                    if ((JSON.stringify(store.getters.snvs[key]["variant_data"]["info_features"]["AF"]) === '{}') == false) {
                        if (columns.includes("allele_frequency") == false) {
                            columns.push("allele_frequency")
                            //alert(this.$store.getters.snvs[key]["variant_data"]["info_features"]["AF"])
                        }
                    }
                }
            }
            //alert(JSON.stringify(this.$store.getters.snvs[key]["dbsnp"]["total"]))
            if ("dbsnp" in store.getters.snvs[key]) {
                if ((JSON.stringify(store.getters.snvs[key]["dbsnp"]["total"]) === '') == false) {
                    //alert("add")
                    if (columns.includes("dbsnp") == false) {
                        columns.push("dbsnp")
                    }
                }
            }
        }
        //}
        store.dispatch("setActiveSNVColumns", columns)
        //alert(columns)
    },
}
